import Header from '../header/Header';
import { Box, Text, useDisclosure } from '@chakra-ui/react';
import { useData } from '../../data';
import { useEffect, useState, useMemo } from 'react';
import Post from './Post';
import CreatePost from './CreatePost';
import FriendRequests from './FriendRequests';
import AdvertFeatureAlt from '../../pages/founder/Dashboard/AdvertFeatureAlt';
import { useWindowSize } from '../../hooks/useWindowSize';
import IsDesktop from '../../utils/IsDesktop';
import RandomFounderCard from './RandomFounderCard';
import ChatMessageWidget from '../ChatMessageWidget';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { useSearchParams, useLocation, useNavigate } from 'react-router-dom';
import Trends from './Trends';
import EventCard from './EventCard';
import OffersList from '../startup-offers/OffersList';
import PinnedAdverts from './PinnedAdverts';
import AdvertDealCard from './AdvertDealCard';
import PromotionalDealPost from './PromotionalDealPost';
import GenericModal from '../modal/GenericModal';

const Feed = () => {
  const loggedInUser = useSelector((state) => state?.user?.userInfo);
  const chatWithUserState = useSelector((state) => state?.chat?.chatInfo);

  const [recipient, setRecipient] = useState(chatWithUserState);
  const [recipientId, setRecipientId] = useState(chatWithUserState?.id || null);

  const [connections, setConnections] = useState([]);
  const [adverts, setAderts] = useState(new Map());
  const [pinAdverts, setpinAderts] = useState([]);
  const [pinDeals, setpinDeals] = useState([]);
  const [promotionalPostPosition] = useState(Math.floor(Math.random() * 3));
  const [hasDeal, setHasDeal] = useState(false);
  const unreads = useSelector((state) => state?.user?.unreads);


  const senderIdsString = useMemo(() => {
    if (!unreads) return '';
    return Object.values(unreads || {}).map(({ senderIds }) => senderIds).join(',');
  }, [unreads]);


  const {
    data: connectionsData,
    isLoading: connectionsLoading,
    refetch: refetchConnections,
  } = useData(
    `users/${loggedInUser?.id}/connections?page_no=1&page_size=20&senderIds=${senderIdsString}`,
    10000,
  );

  const sortFn = (a, b) =>
    moment(
      b?.lastMessage?.createdAt || b?.connection?.created_at || b?.createdAt,
    ).diff(
      moment(
        a?.lastMessage?.createdAt || a?.connection?.created_at || a?.createdAt,
      ),
      'second',
    );

  const [selectedAdvert, setSelectedAdvert] = useState(null);
  const [advertId, setAdvertId] = useState(null);
  const [isAdvert, setIsAdvert] = useState(false);
  const [category, setCategory] = useState(null);

  const {
    isOpen: advertsListIsOpen,
    onOpen: onOpenAdvertsList,
    onClose: onCloseAdvertsList,
  } = useDisclosure();

  const {
    isOpen: advertsListPopupIsOpen,
    onOpen: onOpenAdvertsListPopup,
    onClose: onCloseAdvertsListPopup,
    onToggle: onToggleAdvertsListPopup,
  } = useDisclosure();

  const {
    isOpen: newsIsOpen,
    onOpen: onOpenNews,
    onClose: onCloseNews,
    onToggle: onToggleNews,
  } = useDisclosure();

  const {
    isOpen: requestsIsOpen,
    onOpen: onOpenRequests,
    onToggle: onToggleRequests,
    onClose: onCloseRequests,
  } = useDisclosure();

  const {
    isOpen: offersIsOpen,
    onToggle: onToggleOffers,
    onOpen: onOpenOffers,
    onClose: onCloseOffers,
  } = useDisclosure();

  const {
    isOpen: chatBoxIsOpen,
    onOpen: onOpenChatBox,
    onClose: onCloseChatBox,
    onToggle: onToggleChatBox,
  } = useDisclosure();

  const openChatBox = (recipientId, recipient) => {
    setIsAdvert(false);
    setAdvertId(null);
    setSelectedAdvert(null);
    setRecipientId(recipientId);
    setRecipient(recipient);
    onOpenChatBox();
  };

  const openAdvert = (advertId, advert) => {
    // console.log("opening advert=====", advertId, advert, recipient, recipientId)
    setIsAdvert(true);
    setAdvertId(advertId);
    setSelectedAdvert(advert);
    setRecipient(null);
    setRecipientId(null);
    onOpenChatBox();
  };

  const closeChatBox = () => {
    setRecipientId(null);
    setRecipient(null);
    setAdvertId(null);
    setSelectedAdvert(null);
    onToggleChatBox();
  };

  useEffect(() => {
    if (connectionsData?.data) {
      setHasDeal(connectionsData?.data?.hasDeal || false);
      setConnections(connectionsData?.data?.connections?.sort(sortFn));
    }
    // if (chatWithUserState) {
    //   openChatBox(chatWithUserState?.id, chatWithUserState);
    // }
  }, [connectionsData?.data?.connections, chatWithUserState]);

  const isFromNavigate = () => {
    return (
      chatWithUserState &&
      chatWithUserState?.id === recipientId &&
      chatWithUserState?.connection?.accepted
    );
  };

  // const [page, setPage] = useState(1);

  const [searchParams] = useSearchParams();
  const _postId = searchParams.get('postId');
  const [postId, setPostId] = useState(_postId);
  const location = useLocation();
  const navigate = useNavigate();
  // const navigate = useNavigate();
  const accountType = useSelector(
    (state) => state?.user?.userInfo?.userTypeTitle,
  );

  const [feed, setFeed] = useState([]);

  const { data: advertsData } = useData('adverts');

  const windowSize = useWindowSize();

  const isDesktop = IsDesktop();

  useEffect(() => {
    const redirectPath = sessionStorage.getItem('_redirectPath');
    const pathInfo = redirectPath?.split('?');

    if (pathInfo && pathInfo?.[0] === 'post') {
      const id = pathInfo[1].split('=')[1];
      sessionStorage.removeItem('_redirectPath');
      setPostId(id);
    } else if (pathInfo && pathInfo?.[0] === 'view-user') {
      sessionStorage.removeItem('_redirectPath');
      navigate(`/${redirectPath}`);
    }
  }, [sessionStorage]);

  const {
    data: feedData,
    isLoading: feedDataIsLoading,
    refetch: refetchFeed,
  } = useData(
    `feed?postId=${postId}&category=${encodeURIComponent(category || '')}`,
    10000,
  );

  const { data: feedAdverts, refetch: refetchFeedAdverts } = useData(
    `feed/feed-adverts`,
    10000,
  );

  const { data: pinFeedAdverts } = useData(`adverts/feed-adverts`, 10000);

  const { data: pinDealAdverts } = useData(`adverts/deal-adverts`, 10000);

  useEffect(() => {
    if (feedAdverts) {
      setAderts(
        new Map(
          feedAdverts?.data?.feedAdverts?.map((advert) => [
            advert?.post_id,
            { ...advert?.entity, type: advert?.target_type },
          ]),
        ),
      );
    }
  }, [feedAdverts]);

  useEffect(() => {
    if (pinFeedAdverts) {
      setpinAderts(pinFeedAdverts?.data?.adverts || []);
    }
  }, [pinFeedAdverts]);

  useEffect(() => {
    if (pinDealAdverts) {
      setpinDeals(pinDealAdverts?.data?.deals || []);
    }
  }, [pinDealAdverts]);

  useEffect(() => {
    refetchFeed();
  }, [location.pathname, searchParams, refetchFeed, category]);

  const appendToPostList = (post = null) => {
    if (post) setFeed((prev) => [post, ...prev]);
  };

  useEffect(() => {
    setFeed(feedData?.data?.posts || []);
  }, [feedData, feedDataIsLoading]);

  useEffect(() => {
    if (advertsData?.data?.adverts?.length > 0 && windowSize > 1279) {
      onOpenAdvertsList();
    } else {
      onCloseAdvertsList();
    }
  }, [advertsData?.data?.adverts?.length, windowSize]);

  const filterFeeds = (category) => {
    setCategory(category);
  };

  return (
    <>
      <Box className="w-[100%] flex flex-col overflow-hidden">
        <Box>
          <Header title={'feed'} />
          <Box className="flex w-full bg-gray-100">
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto min-h-[89vh] pt-4 px-5 pb-20  w-full max-w-3xl`}
            >
              {/* Pinned adverts and deals section */}
              <PinnedAdverts
                adverts={pinAdverts}
                maxCount={2}
                pinnedDeals={[]}
              />
              <div className="pl-2 sm:pl-6 w-full overflow-hidden lg:hidden">
                <div className="flex overflow-x-auto hide-scroll space-x-2 py-2 flex-nowrap">
                  <button
                    onClick={onToggleNews}
                    className="
                        flex-shrink-0
                        px-4 py-2
                        text-sm font-medium
                        text-gray-700
                        bg-gray-200
                        rounded-lg
                        hover:bg-gray-300
                      "
                  >
                    What's Happening
                  </button>
                  <button
                    onClick={onToggleRequests}
                    className="
                        flex-shrink-0
                        px-4 py-2
                        text-sm font-medium
                        text-gray-700
                        bg-gray-200
                        rounded-lg
                        hover:bg-gray-300
                      "
                  >
                    Request List
                  </button>
                  {loggedInUser?.userTypeTitle == 'founder' ? (
                    <button
                      onClick={onToggleOffers}
                      className="
                        flex-shrink-0
                        px-4 py-2
                        text-sm font-medium
                        text-gray-700
                        bg-gray-200
                        rounded-lg
                        hover:bg-gray-300
                      "
                    >
                      Offers
                    </button>
                  ) : null}
                  {advertsListIsOpen ? (
                    <button
                      onClick={onToggleAdvertsListPopup}
                      className="
                        flex-shrink-0
                        px-4 py-2
                        text-sm font-medium
                        text-gray-700
                        bg-gray-200
                        rounded-lg
                        hover:bg-gray-300
                      "
                    >
                      Featured Adverts
                    </button>
                  ) : null}
                </div>
              </div>

              <Box className="bg-white mb-5 rounded-lg max-w-2xl mx-auto">
                <CreatePost
                  showCloseButton={false}
                  appendToPostList={appendToPostList}
                  postId={postId}
                  refetchFeed={() => {
                    refetchFeed();
                    refetchFeedAdverts();
                  }}
                />
              </Box>
              <Box className="w-full flex flex-col gap-5 max-w-2xl mx-auto">
                {pinDeals?.length > 0 && accountType === 'investor' && (
                  <AdvertDealCard deal={pinDeals[0]} />
                )}

                {feed?.map((post, index) => {
                  const advertValue = adverts?.get(post.id);

                  return (
                    <Box key={post.id}>
                      <Box className="w-full bg-white rounded-lg">
                        <Post
                          post={post}
                          refetchPost={() => {
                            refetchFeed();
                            refetchFeedAdverts();
                          }}
                          postId={postId}
                        />
                      </Box>

                      {accountType === 'founder' &&
                        !hasDeal &&
                        index === promotionalPostPosition &&
                        index < 3 && (
                          <Box className="w-full mt-5">
                            <PromotionalDealPost />
                          </Box>
                        )}

                      {advertValue?.type === 'event' && (
                        <Box className="w-full mt-5">
                          <EventCard event={advertValue} />
                        </Box>
                      )}

                      {advertValue?.type === 'founder' && (
                        <Box className="w-full mt-5">
                          <RandomFounderCard founder={advertValue} />
                        </Box>
                      )}
                    </Box>
                  );
                })}
              </Box>
            </Box>
            <Box
              className={`hide-scroll max-h-[90vh] overflow-x-auto w-full px-5 max-w-sm hidden lg:flex`}
            >
              <Box className="flex flex-col gap-5 py-4 w-full">
                <FriendRequests />
                <Trends filterFeeds={filterFeeds} />
                {loggedInUser?.userTypeTitle == 'founder' ? (
                  <OffersList
                    showFilters={false}
                    headerClassNames={'text-lg font-bold'}
                    showViewAll={true}
                  />
                ) : null}
              </Box>
            </Box>
            {advertsListIsOpen ? (
              <Box className="hidden bg-white xl:flex flex-col border border-[#DBE2ED] mx-5 my-4 rounded-lg min-w-[270px] max-w-[300px]  min-h-max">
                <Box
                  style={{ boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)' }}
                  className="flex justify-between p-3 border-b border-b-[#DBE2ED] w-full "
                >
                  <Box className="flex items-center w-full gap-1.5">
                    <Text className="font-semibold text-[#2F4B6E]">
                      Featured Adverts
                    </Text>
                  </Box>
                </Box>

                <Box
                  className={`h-full hide-scroll p-3 ${isDesktop ? 'max-h-[100vh] overflow-y-auto' : ''
                    }`}
                >
                  <AdvertFeatureAlt
                    adverts={advertsData?.data?.adverts || []}
                  />
                </Box>
              </Box>
            ) : null}
          </Box>
        </Box>
      </Box>

      <GenericModal isOpen={newsIsOpen} onClose={onCloseNews}>
        <Trends filterFeeds={filterFeeds} />
      </GenericModal>
      <GenericModal isOpen={requestsIsOpen} onClose={onCloseRequests}>
        <FriendRequests />
      </GenericModal>
      <GenericModal isOpen={offersIsOpen} onClose={onCloseOffers}>
        <OffersList
          showFilters={false}
          headerClassNames={'text-lg font-bold'}
          showViewAll={true}
        />
      </GenericModal>
      <GenericModal
        isOpen={advertsListPopupIsOpen}
        onClose={onCloseAdvertsListPopup}
      >
        <Box className="hidden bg-white xl:flex flex-col border border-[#DBE2ED] mx-5 my-4 rounded-lg min-w-[270px] max-w-[300px]  min-h-max">
          <Box
            style={{ boxShadow: '0 4px 20px 0 rgba(0, 0, 0, 0.05)' }}
            className="flex justify-between p-3 border-b border-b-[#DBE2ED] w-full "
          >
            <Box className="flex items-center w-full gap-1.5">
              <Text className="font-semibold text-[#2F4B6E]">
                Featured Adverts
              </Text>
            </Box>
          </Box>

          <Box
            className={`h-full hide-scroll p-3 ${isDesktop ? 'max-h-[100vh] overflow-y-auto' : ''
              }`}
          >
            <AdvertFeatureAlt adverts={advertsData?.data?.adverts || []} />
          </Box>
        </Box>
      </GenericModal>
      <ChatMessageWidget
        requestListIsOpen={false}
        isDesktop={isDesktop}
        connections={connections}
        setConnections={setConnections}
        refetchConnections={refetchConnections}
        connectionsLoading={connectionsLoading}
        sortFn={sortFn}
        recipient={recipient}
        setRecipient={setRecipient}
        recipientId={recipientId}
        selectedAdvert={selectedAdvert}
        advertId={advertId}
        isAdvert={isAdvert}
        isFromNavigate={isFromNavigate}
        openChatBox={openChatBox}
        openAdvert={openAdvert}
        closeChatBox={closeChatBox}
        chatBoxIsOpen={chatBoxIsOpen}
      />
    </>
  );
};

export default Feed;
